import { useState } from 'react'

export function useTableCopy(data) {
  const [copied, setCopied] = useState(false)
  if (!data?.length) return { copied, handleCopy: () => {}, headers: [] }
  const headers = Object.keys(data[0])
  const handleCopy = () => {
    const headerRow = headers.join('\t')
    const bodyRows = data.map((row) => headers.map((h) => row[h]).join('\t')).join('\n')
    navigator.clipboard.writeText(`${headerRow}\n${bodyRows}`)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  return { copied, handleCopy, headers }
}
